import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EfaactMaterialModule } from '../efaact-material/efaact-material.module';
import {
    DialogService,
    FileUploadModule
} from '../shared/efaact-primeng.module';
import { SharedModule } from '../shared/shared.module';
import { UserSelectorModule } from '../user-selector/user-selector.module';
import * as features from './features';
import * as presenters from './presenters';
import {
    ExpenseDetailCityStateZipComponent,
    ExpenseDetailCityStateZipContainerComponent
} from './presenters/expense-detail-city-state-zip';
import * as fromExpense from './store';
import * as fromCity from './store/city';
import * as expenseEffects from './store/effects';
import { ExpensePdboFeatureComponent } from './features/expense-pdbo-feature/expense-pdbo-feature.component';
import { ExpensePdboComponent } from './presenters/expense-pdbo/expense-pdbo.component';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('expenses', fromExpense.reducer),
        StoreModule.forFeature(fromCity.citiesFeatureKey, fromCity.reducer),
        EffectsModule.forFeature([
            expenseEffects.ExpenseEffects,
            fromCity.CityEffects
        ]),
        EfaactMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        UserSelectorModule,
        SharedModule,
        FileUploadModule
    ],
    declarations: [
        features.ExpenseListFeatureComponent,
        features.ExpenseEntryFeatureComponent,
        features.ExpenseReceiptViewFeatureComponent,
        ExpensePdboFeatureComponent,
        presenters.ExpenseListComponent,
        presenters.ExpenseSummaryListComponent,
        presenters.ExpenseDetailListComponent,
        presenters.ExpenseReceiptListComponent,
        presenters.ExpenseEntryComponent,
        presenters.ExpenseReceiptViewPresenterComponent,
        ExpensePdboComponent,
        ExpenseDetailCityStateZipComponent,
        ExpenseDetailCityStateZipContainerComponent
    ],
    providers: [DialogService]
})
export class ExpensesModule {}
